import { openModal } from '@core/components/ModalStack';
import { AddFilesModalProps } from './AddFilesModal';

export async function openAddFiles(props: AddFilesModalProps) {
  const { AddFilesModal } = await import('./AddFilesModal');

  openModal(AddFilesModal, props);
}
